export default {
  type: 'editor.elements.VideoElement',
  name: 'Video',
  editModeTitle: 'Edit Video',
  icon: 'M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z',
  order: 110,
  tooltip: 'Studies show that 96% of consumers are more likely to buy after watching a product video',
};
